import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'bulk-add-claims',

  getComponent(nextState, cb) {
    require.ensure([], require => {
      const BulkAddClaimsContainer = require('./containers/BulkAddClaimsContainer').default
      const bulkAddClaimsReducer = require('./modules/bulkAddClaims').default

      injectReducer(store, {
        key: 'bulkAddClaims',
        reducer: bulkAddClaimsReducer
      })

      cb(null, BulkAddClaimsContainer)
    }, 'bulkAddClaims')
  }
})



// WEBPACK FOOTER //
// ./src/routes/BulkAddClaims/index.js